import queryString from 'query-string';
import { camelCaseToSnakeCase } from '@chargify/formatters';

/**
 * Preapares request query params
 * @param {Record} requestParams - request params object
 * @returns {string}
 */
export const prepareQueryParams = <P>(requestParams: P) =>
  queryString.stringify(camelCaseToSnakeCase(requestParams), {
    arrayFormat: 'comma',
    skipNull: true,
    skipEmptyString: true,
  });
